
/**
 * Extends objects and arrays, replacing current values and adding missing ones
 * @param target - target to add/merge into
 * @param source - source to use
 */
function Extend(target: any = {}, source: any = {})
{
    /**
     * Extend arrays
     */
    if (Array.isArray(source))
    {
        const sourceElementCount = source.length;

        for (let i = 0; i < sourceElementCount; i++)
        {
            const sourceValue = source[i];
            const targetValue = target[i];

            if (Array.isArray(targetValue) || typeof sourceValue === 'object')
            {
                Extend(targetValue, sourceValue);
            }
            else
            {
                target[i] = source[i];
            }
        }
    }

    /**
     * Extend Object
     */
    else if (typeof source === 'object')
    {
        for (let property in source)
        {
            const sourceValue = source[property];

            if(target.hasOwnProperty(property))
            {
                const targetValue = target[property];

                if (Array.isArray(targetValue) || typeof sourceValue === 'object')
                {
                    Extend(targetValue, sourceValue);
                }
                else
                {
                    target[property] = source[property];
                }
            }
            else
            {
                target[property] = source[property];
            }
        }
    }

    return target;
}


export default Extend;